import {
    GETUPDATECOMMOMCONFDETAILSADMIN_SUCCESS,
    GETUPDATECOMMOMCONFDETAILSADMIN_FAILED,
    RESET_GETUPDATECOMMOMCONFDETAILSADMIN,
    LOADING_GETUPDATECOMMOMCONFDETAILSADMIN,
    NETWORK_GETUPDATECOMMOMCONFDETAILSADMIN
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETUPDATECOMMOMCONFDETAILSADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETUPDATECOMMOMCONFDETAILSADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETUPDATECOMMOMCONFDETAILSADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_GETUPDATECOMMOMCONFDETAILSADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETUPDATECOMMOMCONFDETAILSADMIN:
            return (state = initialState);
        default:
            return state;
    }
};